import type { paths } from "../../../lib/api/v1";

// 起票の 3 本の API の型。boron の swagger に名前付きの schema がないため、ここで 1 回だけ取り出す

export const COURSES_PATH =
  "/api/v1/sections/{section_id}/learning_coach/courses" as const;
export const STUDENTS_PATH =
  "/api/v1/sections/{section_id}/learning_coach/students" as const;
export const APPLICATION_REQUESTS_PATH =
  "/api/v1/sections/{section_id}/learning_coach/application_requests" as const;

export type LearningCoachCourse =
  paths[typeof COURSES_PATH]["get"]["responses"]["200"]["content"]["application/json"]["courses"][number];

export type IssuableStudent =
  paths[typeof STUDENTS_PATH]["get"]["responses"]["200"]["content"]["application/json"]["students"][number];

export type IssuanceRejectionReasonCode =
  paths[typeof APPLICATION_REQUESTS_PATH]["post"]["responses"]["422"]["content"]["application/json"]["error"]["reasonCode"];

export type StudentSearchConditions = {
  lastName: string;
  firstName: string;
  job: string[];
  tagIds: string[];
  smartTag: string[];
};

// 姓・名・絞込検索のいずれかを指定したか（ISS-02）
export const hasStudentSearchCondition = ({
  lastName,
  firstName,
  job,
  tagIds,
  smartTag,
}: StudentSearchConditions): boolean =>
  lastName.trim() !== "" ||
  firstName.trim() !== "" ||
  job.length > 0 ||
  tagIds.length > 0 ||
  smartTag.length > 0;

// 起票時点の氏名に、登録されている学年と生徒 ID だけを併記する（申込一覧と同じ）
export const toIssuableStudentLabel = ({
  lastName,
  firstName,
  jobHuman,
  code,
}: IssuableStudent): string => {
  const name = `${lastName} ${firstName}`;
  const details = [jobHuman, code].filter(Boolean);
  return details.length > 0 ? `${name}（${details.join("・")}）` : name;
};
